module.exports = __webpack_public_path__ + "static/img/internet.df780bd7.svg";